import {noop} from '@sdox/utils'

import {Aside} from './Aside'
import {Main} from './Main'
import {DocumentContainer} from './DocumentContainer'

export const Layout = Object.assign(noop, {
  Main,
  Aside,
  DocumentContainer,
})
